import { useCallback, useEffect } from 'react';
import { eventEmitter } from '../../../lib/eventEmmitter';
import { processBackButton, useBackButtonBridge } from '../hooks/useBackButtonBridge';
import { handleNativeLoginResponse } from '../lib/handleNativeLoginResponse';
import { handleNativeLogoutResponse } from '../lib/handleNativeLogoutResponse';
import { sendMessageToNative } from '../lib/sendMessageToNative';
import { validateSafeAreaInsets } from '../lib/validation';
import type { IStorageResponse } from '../types';

let isInitialized = false;

export const NativeBridgeClient = () => {
  // This initializes the global back button bridge. It handles normal back button presses.
  useBackButtonBridge();

  const receiveNativeMessage = useCallback((data: Record<string, unknown>) => {
    try {
      console.log(
        `%creceiveNativeMessage Received message:`,
        'background:blue; color:white;',
        data
      );
      switch (data.type) {
        case 'BACK_BUTTON_PRESSED':
          console.log('BACK_BUTTON_PRESSED');
          processBackButton();
          break;
        case 'CAMERA_ACCESS_RESPONSE':
          console.log('CAMERA_ACCESS_RESPONSE', data.payload);
          eventEmitter.emit('CAMERA_ACCESS_RESPONSE', data.payload);
          break;
        case 'CAMERA_PHOTO_CAPTURED':
          console.log('CAMERA_PHOTO_CAPTURED', data.payload);
          eventEmitter.emit('CAMERA_PHOTO_CAPTURED', data.payload);
          break;
        case 'LOGIN_ERROR':
          console.error('Login error from native:', data.payload);
          break;
        case 'LOGIN_RESPONSE':
          handleNativeLoginResponse(data.payload);
          break;
        case 'LOGOUT_RESPONSE':
          handleNativeLogoutResponse(data.payload);
          break;
        case 'SAFE_AREA_INSETS':
          console.log(`%cSAFE_AREA_INSETS`, 'background:pink; color:black;', data.payload);
          if (validateSafeAreaInsets(data.payload)) {
            eventEmitter.emit('SAFE_AREA_INSETS', data.payload);
          }
          break;
        case 'STORAGE_RESPONSE':
          console.log('STORAGE_RESPONSE', data.payload);
          eventEmitter.emit('STORAGE_RESPONSE', data.payload as IStorageResponse);
          break;
        default:
          console.warn(`No listener found for type: [${data.type}], payload: [${data.payload}]`);
      }
    } catch (error) {
      console.warn('Error parsing message:', error);
      console.warn('Message:', data);
    }
  }, []);

  useEffect(() => {
    if (!isInitialized && window.ReactNativeWebView) {
      window.receiveNativeMessage = receiveNativeMessage;
      sendMessageToNative('COMMS_ESTABLISHED');
      isInitialized = true;
    }
  }, [receiveNativeMessage]);

  return null;
};
